import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import SearchIcon from '@mui/icons-material/Search';
import ZoomInIcon from '@mui/icons-material/ZoomIn';

import i18n from 'FRONTEND/utils/i18n';

export const getExpertStepSupport = () => {
  return {
    title: i18n._('How to find the practitioner?'),
    text: i18n._('You are able to book an appointment for any user that delegated their calendar management to you in their profile settings.'),
    paragraphList: [
      {
        title: i18n._('Type at least three letters to search'),
        text: i18n._('In order for the search to give results, you need to supply at least three consecutive characters contained in the practitioner’s name.'),
        icon: SearchIcon,
      },
      {
        title: i18n._('Be more specific to narrow down the search'),
        text: i18n._('Only a maximum of 15 results are shown at a time. Type more characters to reduce the number of matching practitioners and find the one you are looking for.'),
        icon: ZoomInIcon,
      },
      {
        title: i18n._('Check that you can manage the practitioner’s calendar'),
        text: i18n._('Make sure that the practitioner delegated their calendar management to you in their profile settings.'),
        icon: PermContactCalendarIcon,
      },
    ],
  };
};
